module.exports = __webpack_public_path__ + "img/jaune-5.c937c294.png";